import React, { useState } from 'react'
import messages from './messages'
import { useIntl, FormattedMessage } from 'react-intl'
import { Modal, Button, Input, File } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useDropzone } from 'react-dropzone'

export default NiceModal.create(({ task, order }) => {
  const [files, setFiles] = useState([])
  const [wordCount, setWordCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const { formatMessage } = useIntl()
  const modal = useModal()

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop: setFiles })

  const onSubmit = (event) => {
    event.preventDefault()
    setLoading(true)

    const promises = files.map((file) => {
      const body = new FormData()
      body.append('taskid', task.uid)
      body.append('addFileIsSource', 0)
      body.append('addFileWordcount', wordCount)
      body.append('addFileFile', file)

      return fetch(`/ordertask/uploadspeak.json`, { method: 'POST', body })
        .then((response) => response.json())
        .then(({ success, errors }) => !success && window?.toastr.error(errors.join(', ')))
    })

    Promise.all(promises)
      .then(() => setLoading(false))
      .then(() => {
        modal.resolve({ refetchFiles: true })
        modal.remove()
      })
      .catch((error) => window?.toastr.error(error))
  }


  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      title={formatMessage(messages.title)}
    >
      <form className="space-y-4 mt-4" onSubmit={onSubmit} disabled={loading}>
        <div className="flex justify-between items-center">
          <label className="font-medium text-sm text-gray-600">
            Word count
          </label>

          <div className="w-1/4">
            <Input
              size="sm"
              type="text"
              value={wordCount}
              onChange={(event) => setWordCount(event.target.value)}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2">
          { files.map((file, index) => (
            <File
              title={file.name}
              fileSize={file.size}
              key={index}
              uploading={loading}
            />
          )) }
        </div>

        <div className="w-full h-20 flex items-center justify-center border border-gray-300 border-dashed shadow-inner cursor-pointer" {...getRootProps()}>
          <div>
            <input {...getInputProps()} />

            <div className="w-full text-sm text-center px-2 py-4 text-gray-500">
              {
                loading ?
                  <p>Uploading files..</p>
                : isDragActive ?
                  <p>Drop the files here ...</p>
                :
                  <p>Drag and drop files here, or <span className="text-primary font-medium">click</span> to select files</p>
              }
            </div>
          </div>
        </div>

        <ol className="text-sm text-gray-600">
            <FormattedMessage
              {...messages.sideEffects}
              values={{
                li: (chunks) => <li className="">{chunks}</li>,
              }}
            />
        </ol>

        <div className="flex justify-end items-center space-x-2">
          <Button type="submit" size="sm" disabled={loading}>
            { loading ? (
              <FormattedMessage {...messages.loading} />
            ) : (
              <FormattedMessage {...messages.submit} />
            ) }
          </Button>

          <Button type="button" size="sm" onClick={() => modal.remove()} variant="outline">
            <FormattedMessage {...messages.cancel} />
          </Button>
        </div>
      </form>
    </Modal>
  )
})
